import React, { useState } from 'react';
import { ExternalLink, TrendingUp, Linkedin, ChevronDown, ChevronUp } from 'lucide-react';
import { linkedInPostsData } from '../data/mock';
import { Button } from './ui/button';

const LinkedInPosts = () => {
  const [expandedPost, setExpandedPost] = useState(null);

  const togglePost = (postId) => {
    setExpandedPost(expandedPost === postId ? null : postId);
  };

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#0077B5]/10 text-[#0077B5] px-4 py-2 rounded-full mb-4">
            <Linkedin size={20} />
            <span className="font-semibold">Insights de LinkedIn</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#013139] mb-4">
            Últimas reflexiones sobre IA
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Descubre las tendencias y estrategias que comparto con la comunidad profesional
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-6">
          {linkedInPostsData.map((post) => (
            <div
              key={post.id}
              className="bg-gradient-to-br from-white to-gray-50 rounded-2xl border-2 border-gray-100 hover:border-[#00E5A3] transition-all duration-300 overflow-hidden shadow-lg hover:shadow-xl"
            >
              {/* Header */}
              <div className="p-6 border-b border-gray-100 bg-white">
                <div className="flex items-start justify-between gap-4">
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#013139] to-[#024F5B] flex items-center justify-center">
                        <TrendingUp className="text-[#00E5A3]" size={24} />
                      </div>
                      <div>
                        <h3 className="font-bold text-[#013139]">Emilio Sáez Yebra</h3>
                        <p className="text-sm text-gray-500">{post.date}</p>
                      </div>
                    </div>
                    <h4 className="text-lg font-bold text-[#013139] leading-tight">
                      {post.title}
                    </h4>
                  </div>
                  <a
                    href={post.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#0077B5] hover:text-[#005582] transition-colors"
                  >
                    <Linkedin size={24} />
                  </a>
                </div>
              </div>

              {/* Content Preview */}
              <div className="p-6">
                <p className="text-gray-700 leading-relaxed mb-4 whitespace-pre-line">
                  {expandedPost === post.id ? post.content : post.excerpt}
                </p>

                {/* Key Points */}
                {expandedPost === post.id && (
                  <div className="mt-6 space-y-3 animate-fade-in">
                    <p className="font-semibold text-[#013139] mb-3">
                      📌 Puntos clave:
                    </p>
                    {post.keyPoints.map((point, index) => (
                      <div key={index} className="flex items-start gap-3 bg-white p-4 rounded-lg border border-gray-100">
                        <div className="w-2 h-2 bg-[#00E5A3] rounded-full mt-2 flex-shrink-0" />
                        <p className="text-gray-700 text-sm">{point}</p>
                      </div>
                    ))}

                    {/* Hashtags */}
                    <div className="flex flex-wrap gap-2 mt-4 pt-4 border-t border-gray-200">
                      {post.hashtags.map((tag, index) => (
                        <span
                          key={index}
                          className="text-[#00E5A3] text-sm font-medium"
                        >
                          #{tag}
                        </span>
                      ))}
                    </div>
                  </div>
                )}

                {/* Toggle Button */}
                <button
                  onClick={() => togglePost(post.id)}
                  className="mt-4 flex items-center gap-2 text-[#013139] hover:text-[#00E5A3] font-semibold transition-colors"
                >
                  {expandedPost === post.id ? (
                    <>
                      Ver menos
                      <ChevronUp size={20} />
                    </>
                  ) : (
                    <>
                      Leer más
                      <ChevronDown size={20} />
                    </>
                  )}
                </button>
              </div>

              {/* Footer */}
              <div className="px-6 py-4 bg-gray-50 border-t border-gray-100">
                <a
                  href={post.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-[#0077B5] hover:text-[#005582] font-semibold transition-colors"
                >
                  Ver publicación completa en LinkedIn
                  <ExternalLink size={16} />
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* CTA to LinkedIn Profile */}
        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-6">
            ¿Quieres estar al día con las últimas tendencias en IA y automatización?
          </p>
          <Button
            onClick={() => window.open('https://www.linkedin.com/in/emilio-s%C3%A1ez-yebra-1b65b8164/', '_blank')}
            className="bg-[#0077B5] hover:bg-[#005582] text-white font-semibold"
          >
            <Linkedin className="mr-2" size={20} />
            Sígueme en LinkedIn
          </Button>
        </div>
      </div>
    </section>
  );
};

export default LinkedInPosts;
